import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import TextField from "@material-ui/core/TextField";
import TablePagination from "@material-ui/core/TablePagination";
import DatePicker from "react-datepicker";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import ArrowDropUp from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import TableHead from "@material-ui/core/TableHead";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import {
  ROWS_PER_PAGE_OPTIONS,
  BACKEND_DATE_FORMAT,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import CustomTableHead from "../components/CustomTableHead";
import OutstandingItemDetails from "../details/OutstandingItemDetails";
import PaidItemDetails from "../details/PaidItemDetails";
import PopupMessage from "../components/PopupMessage";
import ViewPdf from "../components/ViewPdf";
import CustomPaginatorActions from "../components/CustomPaginatorActions";
import downloadjs from "downloadjs";

import SearchIcon from "@material-ui/icons/PageviewOutlined";
import PDFViewIcon from "@material-ui/icons/PictureAsPdfOutlined";
import DownloadFileIcon from "@material-ui/icons/MoveToInboxOutlined";
import CircularProgress from "@material-ui/core/CircularProgress";

import { Portal } from "react-overlays";

import { AmountFormatCustom } from "../components/AmountFormatCustom";

const CalendarContainer = ({ children }) => {
  const el = document.getElementById("calendar-portal");

  return <Portal container={el}>{children}</Portal>;
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  boldCell: {
    fontWeight: "bold",
    fontSize: 14,
  },
  summaryTable: {
    width: 400,
    border: "0px solid black",
    margin: "20px",
  },
  progress: {
    margin: theme.spacing.unit,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "secondary",
      cursor: "pointer",
    },
  },
});

const columnData = [
  { id: "1", numeric: false, disablePadding: false, label: "Issue Date" },
  { id: "2", numeric: false, disablePadding: false, label: "Paid Date" },
  { id: "3", numeric: false, disablePadding: false, label: "Check No." },
  { id: "4", numeric: false, disablePadding: false, label: "Status" },
  { id: "5", numeric: false, disablePadding: false, label: "Payee" },
  { id: "6", numeric: true, disablePadding: false, label: "Paid Amount($)" },
  { id: "7", numeric: true, disablePadding: false, label: "Issue Amount($)" },
];

class ConsolidatedAccountItemsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      checkFrom: "",
      checkTo: "",
      amountFrom: "",
      amountTo: "",
      payee: "",
      items: [],
      summary: [],
      selectedItemId: 0,
      totalAmount: "",
      selectedItemObject: {},
      order: "asc",
      orderBy: "6",
      page: 0,
      rowsPerPage: window.sco_large_items_per_page,
      totalCount: 0,
      canSearch: false,
      selectedReason: "-1",
      startDate: null,
      redrawStartDate: false,
      redrawEndDate: false,
      endDate: null,
      backendStartDate: "",
      backendEndDate: "",
      waitingDownload: false,
      validated: false,
      viewPdf: false,
      collapsedSearch: false,
      searchItemsInProgress: false,
      viewPopup: false,
      selectedSort: "1",      	  
    };
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  handleChange(e) {
    e.preventDefault();
    this.props.onReportChange(e);
  }

  handleSort(e) {
    this.setState({ selectedSort: e.target.value });
    if (e.target.value === "1") {
      this.setState({ orderBy: "6" });
    }          
    if (e.target.value === "2") {
      this.setState({ orderBy: "5" });
    }   
    if (e.target.value === "3") {
      this.setState({ orderBy: "0" });
    }		
  }

  componentDidUpdate() {
    if (this.state.redrawStartDate) {
      this.setState({ redrawStartDate: false });
    }
    if (this.state.redrawEndDate) {
      this.setState({ redrawEndDate: false });
    }
    if (this.state.waitingDownload && this.state.validated) {
      this.setState({ validated: false });
      this.setState({ waitingDownload: false });
      let myUrl = this.getUrl(
        "on_download_file",
        this.state.rowsPerPage,
        this.state.page,
        this.state.order,
        this.state.orderBy,
        true
      );
      this.downloadFile(myUrl, true);
    }
  }

  disableSearch() {
    this.setState({ canSearch: false });
    this.setState({ totalCount: 0 });
    this.setState({ page: 0 });
    this.setState({ searchItemsInProgress: false });
  }

  handleSearch(e) {
    if (!this.validateDates()) {
      return;
    }
    this.setState({ canSearch: true });
    this.setState({ searchItemsInProgress: true });
    let myUrl = this.getUrl(
      "on_search_consolidated_items_request",
      this.state.rowsPerPage,
      this.state.page,
      this.state.order,
      this.state.orderBy,
      false
    );
    this.search(
      myUrl,
      this.state.rowsPerPage,
      this.state.page,
      this.state.order,
      this.state.orderBy,
      false
    );
  }

  handlePdf(e) {
    if (!this.validateDates()) {
      return;
    }
    this.setState({ viewPdf: true });
  }

  handleDownload(e) {
    if (!this.validateDates()) {
      return;
    }
    this.setState({ waitingDownload: true });
    this.setState({ validated: false });
    let myUrl = this.getUrl(
      "on_search_consolidated_items_request",
      this.state.rowsPerPage,
      this.state.page,
      this.state.order,
      this.state.orderBy,
      true
    );
    this.search(
      myUrl,
      this.state.rowsPerPage,
      this.state.page,
      this.state.order,
      this.state.orderBy,
      true
    );
  }

  validateDates() {
    let start = this.state.startDate;
    let end = this.state.endDate;
    if (start !== null && end !== null && end.isBefore(start, "day")) {
      this.setState({
        errorString: getErrorString(
          "general.error.endDate",
          "End Date is before Start Date"
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }
    return true;
  }

  downloadFile(myUrl, validate) {
    let validateOnly = validate === true ? "yes" : null;
    let sortorder = this.state.order === "asc" ? 1 : 2;
    fetch(myUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        option: this.props.option.id,
        sortorder: sortorder,
        sorttype: this.state.orderBy,
        startDate: this.state.backendStartDate,
        endDate: this.state.backendEndDate,
        reason: this.state.selectedReason,
        checkFrom: this.state.checkFrom,
        checkTo: this.state.checkTo,
        amountFrom: this.state.amountFrom,
        amountTo: this.state.amountTo,
        payee: this.state.payee,
        rowsPerPage: this.state.rowsPerPage,
        page: this.state.page,
        validateOnly: validateOnly,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.blob())
      .then((blob) => {
        downloadjs(blob, "itemfile.zip", "application/zip");
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  handleCollapse = (event) => {
    this.setState({ collapsedSearch: !this.state.collapsedSearch });
  };

  handleStartDate(date) {
    this.disableSearch();
    this.setState({ startDate: date });
    if (date === null) {
      this.setState({ backendStartDate: "" });
    } else {
      this.setState({ backendStartDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }

  handleStartDateOutsideClick(e) {
    this.setState({ redrawStartDate: true });
  }

  handleEndDate(date) {
    this.disableSearch();
    this.setState({ endDate: date });
    if (date === null) {
      this.setState({ backendEndDate: "" });
    } else {
      this.setState({ backendEndDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }

  handleEndDateOutsideClick(e) {
    this.setState({ redrawEndDate: true });
  }

  handleCheckFrom(e) {
    this.disableSearch();
    this.setState({ checkFrom: e.target.value });
  }

  handleCheckTo(e) {
    this.disableSearch();
    this.setState({ checkTo: e.target.value });
  }

  handleAmountFrom(e) {
    this.disableSearch();
    this.setState({ amountFrom: e.target.value });
  }

  handleAmountTo(e) {
    this.disableSearch();
    this.setState({ amountTo: e.target.value });
  }

  handlePayee(e) {
    this.disableSearch();
    this.setState({ payee: e.target.value });
  }

  handleReason(e) {
    this.disableSearch();
    this.setState({ selectedReason: e.target.value });
  }

  handleChangeRowsPerPage(e) {
    this.setState({ rowsPerPage: e.target.value });
    this.setState({ page: 0 });
    window.sco_large_items_per_page = e.target.value;
    if (this.state.canSearch) {
      let myUrl = this.getUrl(
        "on_search_consolidated_items_request",
        e.target.value,
        0,
        this.state.order,
        this.state.orderBy,
        false
      );
      this.search(
        myUrl,
        e.target.value,
        0,
        this.state.order,
        this.state.orderBy,
        false
      );
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page });
    if (this.state.canSearch) {
      let myUrl = this.getUrl(
        "on_search_consolidated_items_request",
        this.state.rowsPerPage,
        page,
        this.state.order,
        this.state.orderBy,
        false
      );
      this.search(
        myUrl,
        this.state.rowsPerPage,
        page,
        this.state.order,
        this.state.orderBy,
        false
      );
    }
  };

  handleRequestSort = (event, property) => {
    if (property.indexOf("nosort") !== -1) {
      return;
    }
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property) {
      if (this.state.order === "desc") {
        order = "asc";
      }
    } else {
      order = this.state.order;
    }
    this.setState({ order, orderBy });
    let myUrl = this.getUrl(
      "on_search_consolidated_items_request",
      this.state.rowsPerPage,
      this.state.page,
      order,
      orderBy,
      false
    );
    this.search(
      myUrl,
      this.state.rowsPerPage,
      this.state.page,
      order,
      orderBy,
      false
    );
  };

  handleSelectItem(event, itemKey) {
    this.setState({ selectedItemObject: this.state.items[itemKey - 1] });
    this.setState({ selectedItemId: itemKey });
  }

  getUrl(requestType, curRowsPerPage, curPage, order, orderBy, validateOnly) {
    return requestType;
  }

  getBaseUrl(requestType, order, orderBy) {
    return requestType;
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ viewPdf: false });
    this.setState({ waitingDownload: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
    this.setState({ selectedItemId: 0 });
  }

  search(myUrl, rowsPerPage, page, order, orderBy, validate) {
    let validateOnly = validate === true ? "yes" : null;
    let sortorder = order === "asc" ? 1 : 2;
    fetch(myUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        option: this.props.option.id,
        sortorder: sortorder,
        sorttype: orderBy,
        startDate: this.state.backendStartDate,
        endDate: this.state.backendEndDate,
        reason: this.state.selectedReason,
        checkFrom: this.state.checkFrom,
        checkTo: this.state.checkTo,
        amountFrom: this.state.amountFrom,
        amountTo: this.state.amountTo,
        payee: this.state.payee,
        rowsPerPage: rowsPerPage,
        page: page,
        validateOnly: validateOnly,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          this.setState({ searchItemsInProgress: false });
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else {
            if (validate) {
              this.setState({ validated: true });
            } else {
              let newItems = reply.items;
              this.setState({ items: newItems });
              this.setState({ totalCount: reply.totalCount });
              this.setState({ summary: reply.summary });
              if (reply.totalCount === 0) {
                this.setState({ viewPopup: true });
                this.setState({
                  notifyString: getErrorString(
                    "general.info.search.empty",
                    "Total number of items is 0."
                  ),
                });
              }
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ searchItemsInProgress: false });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  isSelected = (id) => this.state.selectedItemId === id;

  getSearchObject(page, rowsPerPage) {
    let data = {
      r: new Date().getTime(),
      secureToken: this.props.secureToken,
      transit: this.props.accountObject.transit,
      account: this.props.accountObject.account,
      option: this.props.option.id,
      sorttype: this.state.orderBy,
      startDate: this.state.backendStartDate,
      endDate: this.state.backendEndDate,
      reason: this.state.selectedReason,
      checkFrom: this.state.checkFrom,
      checkTo: this.state.checkTo,
      amountFrom: this.state.amountFrom,
      amountTo: this.state.amountTo,
      payee: this.state.payee,
      rowsPerPage: this.state.rowsPerPage,
      page: this.state.page,
    };
    return data;
  }

  render() {
    const { classes } = this.props;
    let { t } = this.props;
    const reasons = this.props.reasons;
    const { order, orderBy, rowsPerPage, page, totalCount } = this.state;
    const datePickerTopMargin = this.props.option.id === "O" ? 10 : 6;
    const actionTopMargin = this.props.option.id === "O" ? 4 : 0;
    let data = this.state.items;
    let summary = this.state.summary;
    let options = this.props.reports;
    let myPdfUrl = this.getBaseUrl(
      "on_search_consolidated_items_pdf_request",
      this.state.order,
      this.state.orderBy
    );
    return (
      <div>
        {this.state.viewPdf && (
          <ViewPdf
            history={this.props.history}
            secureToken={this.props.secureToken}
            onClosePopup={this.onClosePopup}
            postData={this.getSearchObject(page, rowsPerPage)}
            pdfUrl={myPdfUrl}
            page={page}
            rowsPerPage={rowsPerPage}
          />
        )}
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.selectedItemId !== 0 &&
          (this.state.selectedItemObject.status === "I" ||
            this.state.selectedItemObject.status === "V") && (
            <div>
              <OutstandingItemDetails
                item={this.state.selectedItemObject}
                history={this.props.history}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                secureToken={this.props.secureToken}
                accountObject={this.props.accountObject}
                onClosePopup={this.onClosePopup}
                option={this.props.option}
                onAction={this.onSelectedAction}
                canDelete={this.state.canDelete}
                canEdit={this.state.canEdit}
              />
            </div>
          )}
        {this.state.selectedItemId !== 0 &&
          this.state.selectedItemObject.status === "P" && (
            <div>
              <PaidItemDetails
                item={this.state.selectedItemObject}
                history={this.props.history}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                secureToken={this.props.secureToken}
                accountObject={this.props.accountObject}
                onClosePopup={this.onClosePopup}
                option={this.props.option}
                onAction={this.onSelectedAction}
                canDelete={this.state.canDelete}
                canEdit={this.state.canEdit}
              />
            </div>
          )}
        {this.state.selectedItemId === 0 && (
          <div>
            {this.state.selectedItemId === 0 && (
              <div>
                <Paper elevation={5}>
                  <FormGroup row>
                    <div>
                      <Typography variant="caption">
                        {t("report.label")}&nbsp;&nbsp;
                      </Typography>
                      <FormControl>
                        <NativeSelect
                          style={{
                            height: 48,
                            verticalAlign: "textTop",
                            margin: 0,
                          }}
                          defaultValue={this.props.option.index}
                          input={<Input id="report_options" />}
                          onChange={(event) => this.handleChange(event)}
                        >
                          {options.map((n) => {
                            return (
                              <option value={n.index}>{n.description}</option>
                            );
                          })}
                        </NativeSelect>
                      </FormControl>
                      &nbsp;&nbsp;
                    </div>
                    {!this.props.option.disableReason && (
                      <div>
                        <Typography variant="caption">
                          {t("exceptionReason.label")}
                        </Typography>
                        <FormControl>
                          <NativeSelect
                            style={{
                              height: 48,
                              verticalAlign: "textTop",
                              margin: 0,
                            }}
                            defaultValue={this.state.selectedReason}
                            input={<Input id="reason_options" />}
                            onChange={(event) => this.handleReason(event)}
                          >
                            {reasons.map((n) => {
                              return (
                                <option value={n.id}>{n.description}</option>
                              );
                            })}
                          </NativeSelect>
                        </FormControl>
                        &nbsp;&nbsp;
                      </div>
                    )}
                    {!this.props.option.disableStartDate && (
                      <div>
                        <Typography variant="caption">
                          {t("startDate.label")}
                          {!this.state.redrawStartDate && (
                            <div style={{ marginTop: datePickerTopMargin }}>
                              <DatePicker
                                isClearable
                                disabledKeyboardNavigation
                                dateFormat="LL"
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                selected={this.state.startDate}
                                onChange={(event) =>
                                  this.handleStartDate(event)
                                }
                                onClickOutside={(event) =>
                                  this.handleStartDateOutsideClick(event)
                                }
                                popperContainer={CalendarContainer}
                              />
                            </div>
                          )}
                        </Typography>
                      </div>
                    )}
                    &nbsp;&nbsp;
                    {!this.props.option.disableEndDate && (
                      <div>
                        <Typography variant="caption">
                          {t("endDate.label")}
                          {!this.state.redrawEndDate && (
                            <div style={{ marginTop: datePickerTopMargin }}>
                              <DatePicker
                                isClearable
                                disabledKeyboardNavigation
                                dateFormat="LL"
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                selected={this.state.endDate}
                                onChange={(event) => this.handleEndDate(event)}
                                onClickOutside={(event) =>
                                  this.handleEndDateOutsideClick(event)
                                }
                                popperContainer={CalendarContainer}
                              />
                            </div>
                          )}
                        </Typography>
                        &nbsp;&nbsp;
                      </div>
                    )}
                    <div>
                     <Typography variant="caption">
                       {t("sort.label")}&nbsp;&nbsp;
                     </Typography>
                     <FormControl>
                       <NativeSelect
                          style={{ height: 48, verticalAlign: "textTop", margin: 0 }}
                          defaultValue={this.state.selectedSort}
                          input={<Input id="sort_options" />}
                          onChange={(event) => this.handleSort(event)}
                        >                      
                          <option value="1">{t("amount.label")}</option>
                          <option value="2">{t("payee.label")}</option>
                          <option value="3">{t("default.label")}</option>						  
                        </NativeSelect>
                     </FormControl>
                     &nbsp;&nbsp;
                    </div>                    					
                    <Tooltip
                      title={
                        t("showSearchResult.tip") +
                        this.props.option.description
                      }
                    >
                      <Button
                        color="primary"
                        style={{ marginTop: actionTopMargin }}
                        onClick={(event) => this.handleSearch(event)}
                      >
                        <SearchIcon />
                        &nbsp;{t("search.button")}
                      </Button>
                    </Tooltip>
                    {!this.props.option.disablePdf && (
                      <Tooltip title={t('"viewPdfReport.tip')}>
                        <Button
                          color="primary"
                          style={{ marginTop: actionTopMargin }}
                          onClick={(event) => this.handlePdf(event)}
                        >
                          <PDFViewIcon />
                          &nbsp;{t("pdf.button")}
                        </Button>
                      </Tooltip>
                    )}
                    {!this.props.option.disableFileDownload && (
                      <Tooltip title={t("downLoadItemsFile.tip")}>
                        <Button
                          color="primary"
                          style={{ marginTop: actionTopMargin }}
                          onClick={(event) => this.handleDownload(event)}
                        >
                          <DownloadFileIcon />
                          &nbsp;{t("download.button")}
                        </Button>
                      </Tooltip>
                    )}
                    {!this.state.collapsedSearch && (
                      <Tooltip title={t("collaspSearch.tip")}>
                        <IconButton
                          style={{ position: "absolute", right: 10, top: 0 }}
                          onClick={(event) => this.handleCollapse(event)}
                        >
                          <ArrowDropUp />
                        </IconButton>
                      </Tooltip>
                    )}
                    {this.state.collapsedSearch && (
                      <Tooltip title={t("expandSearch.tip")}>
                        <IconButton
                          style={{ position: "absolute", right: 10, top: 0 }}
                          onClick={(event) => this.handleCollapse(event)}
                        >
                          <ArrowDropDown />
                        </IconButton>
                      </Tooltip>
                    )}
                  </FormGroup>

                  {!this.state.collapsedSearch && (
                    <FormGroup row>
                      {!this.props.option.disableFromCheck && (
                        <TextField
                          margin="dense"
                          id="checkFrom"
                          label={t("checkNoFrom.label")}
                          type="text"
                          defaultValue={this.state.checkFrom}
                          onChange={(event) => this.handleCheckFrom(event)}
                          onKeyPress={(event) => {
                            return event.charCode >= 48 && event.charCode <= 57
                              ? true
                              : event.preventDefault();
                          }}
                        />
                      )}
                      &nbsp;&nbsp;
                      {!this.props.option.disableToCheck && (
                        <TextField
                          margin="dense"
                          id="checkTo"
                          label={t("checkNoTo.label")}
                          type="text"
                          defaultValue={this.state.checkTo}
                          onChange={(event) => this.handleCheckTo(event)}
                          onKeyPress={(event) => {
                            return event.charCode >= 48 && event.charCode <= 57
                              ? true
                              : event.preventDefault();
                          }}
                        />
                      )}
                      &nbsp;&nbsp;
                      {!this.props.option.disableFromAmount && (
                        <TextField
                          margin="dense"
                          id="amountFrom"
                          label={t("amountFrom.label")}
                          type="text"
                          defaultValue={this.state.amountFrom}
                          onChange={(event) => this.handleAmountFrom(event)}
                          InputProps={{
                            inputComponent: AmountFormatCustom,
                          }}
                        />
                      )}
                      &nbsp;&nbsp;
                      {!this.props.option.disableToAmount && (
                        <TextField
                          margin="dense"
                          id="amountTo"
                          label={t("amountTo.label")}
                          type="text"
                          defaultValue={this.state.amountTo}
                          onChange={(event) => this.handleAmountTo(event)}
                          InputProps={{
                            inputComponent: AmountFormatCustom,
                          }}
                        />
                      )}
                      &nbsp;&nbsp;
                      {!this.props.option.disableePayee && (
                        <TextField
                          margin="dense"
                          id="payee"
                          label={t("payeeName.label")}
                          defaultValue={this.state.payee}
                          onChange={(event) => this.handlePayee(event)}
                        />
                      )}
                    </FormGroup>
                  )}
                </Paper>
              </div>
            )}
            <Divider />
            {this.state.selectedItemId === 0 &&
              this.state.errorString.length === 0 &&
              this.state.searchItemsInProgress && (
                <div className={classes.tableWrapper}>
                  <CircularProgress className={classes.progress} />
                </div>
              )}
            <TablePagination
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
              page={page}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={(event) =>
                this.handleChangeRowsPerPage(event)
              }
              ActionsComponent={CustomPaginatorActions}
            />
            {this.state.canSearch &&
              this.state.selectedItemId === 0 &&
              this.state.totalCount > 0 && (
                <Paper elevation={5}>
                  <Table
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    stickyHeader
                  >
                    <CustomTableHead
                      order={order}
                      orderBy={orderBy}
                      columnData={columnData}
                      onRequestSort={this.handleRequestSort}
                    />
                    <TableBody>
                      {data.map((n) => {
                        const isSelected = this.isSelected(n.index);
                        return (
                          <TableRow
                            hover
                            className={classes.tableRow}
                            onClick={(event) =>
                              this.handleSelectItem(event, n.index)
                            }
                            key={n.index}
                            selected={isSelected}
                            title={t("viewDetail.label")}
                          >
                            <TableCell style={{ width: "10%" }}>
                              {n.issueDate}
                            </TableCell>
                            <TableCell style={{ width: "10%" }}>
                              {n.paidDate}
                            </TableCell>
                            <TableCell style={{ width: "12%" }}>
                              {n.checkNumber}
                            </TableCell>
                            <TableCell style={{ width: "6%" }}>
                              {n.status}
                            </TableCell>
                            <TableCell
                              style={{ width: "40%", wordWrap: "break-word" }}
                            >
                              {n.payee}
                            </TableCell>
                            <TableCell numeric={true} style={{ width: "12%" }}>
                              {n.paidAmount}
                            </TableCell>
                            <TableCell numeric={true} style={{ width: "10%" }}>
                              {n.issueAmount}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Paper>
              )}
            {this.state.canSearch && this.state.summary.length > 0 && (
              <Paper elevation={5}>
                <br />
                <p> &nbsp;&nbsp;{t("summary.label")}</p>
                <Table className={classes.summaryTable} stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>{t("type.label")}</TableCell>
                      <TableCell>{t("count.header")}</TableCell>
                      <TableCell numeric={true}>{t("amount.header")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {summary.map((n) => {
                      return (
                        <TableRow key={n.type}>
                          <TableCell>{n.type}</TableCell>
                          <TableCell>{n.count}</TableCell>
                          <TableCell numeric={true}>{n.amount}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                <br />
                <br />
                <br />
              </Paper>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(
  withStyles(styles)(ConsolidatedAccountItemsPage)
);
